import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { ToastContainer, toast } from 'react-toastify';
import Web3 from 'web3';

function Trade() {

    const BSC_RPC_URL = 'https://bsc-dataseed.binance.org/'; // Replace with your preferred BSC RPC URL
    const CHAIN_ID = 56; // Mainnet

    const [tableData, setTabledata] = useState([]);
    const [isData, setData] = useState(false);

    const [web3, setWeb3] = useState(null);
    const [wallet, setWallet] = useState(null);
    const [isWalletConnected, setIsWalletConnected] = useState(false);

    //Select Asset for Withdraw 
    const [withdrawAsset, setWithdrawAsset] = useState("USDT");
    const [rainoAmount, setRainoAmount] = useState(null);
    const [usdtAmount, setUsdtAmount] = useState(null);
    const [connectedStatus, setConnectedStatus] = useState("Disconnected");

    // console.log("Withdraw Asset =", withdrawAsset, withdrawAmount);

    const [isLoading, setLoadning] = useState(false);

    const Api = process.env.REACT_APP_API_URL
    const apiKey = process.env.REACT_APP_API_KEY


    const [usdtConAddress, setUsdttCoinContractAddress] = useState("0x55d398326f99059fF775485246999027B3197955");
    const usdtAbi = JSON.parse('[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]');


    const [rainoConAddress, setRainoCoinContractAddress] = useState("0x339A5946b305bDD7FA7c54309cef53779b119457");
    const rainoAbi = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');




    const setrainoAmounts = async (rainocount) => {
        const swapUsdtAmoutn = rainocount * localStorage.getItem('adminCoinPrice');
        setRainoAmount(rainocount);
        setUsdtAmount(swapUsdtAmoutn);
    };

    const setusdtAmounts = async (usdtocount) => {
        const swaprainoAmoutn = usdtocount / localStorage.getItem('adminCoinPrice');
        setRainoAmount(swaprainoAmoutn);
        setUsdtAmount(usdtocount);
    };



    const walletConnect = async () => {



        if (window.ethereum) {
            try {
                // Request account access if needed
                await window.ethereum.enable();

                // Create a new web3 instance with the provider
                const web3Instance = new Web3(window.ethereum || "https://bsc-dataseed.binance.org/");
                //Connect with only BSC CHAIN Network
                // const web3Instance = new Web3(BSC_RPC_URL);



                // Set the web3 instance and user's account address
                setWeb3(web3Instance);
                const accounts = await web3Instance.eth.getAccounts();
                // getMyAccount(accounts[0]);
                if (window.ethereum && window.ethereum.selectedAddress) {

                    updateWallet(accounts[0]);
                    //setIsWalletConnected(true);
                }

            } catch (error) {
                console.error('Error connecting to the wallet:', error);
                toast.error(error, { position: toast.POSITION.TOP_RIGHT, });
            }
        } else {
            console.error('Non-Ethereum browser detected. You should consider trying MetaMask!');
            toast.error('Please Loin in any Blockchain Wallet Like Metamask and Trust Wallet', { position: toast.POSITION.TOP_RIGHT, });
        }

    }


    const updateWallet = async (userAdderss) => {

        try {

            const userId = localStorage.getItem('id');

            fetch('https://rainocoin.com/api/check_wallet.php?id=' + userId + '&wallet=' + userAdderss + '&type=trade')
                .then(res => res.json())
                .then(
                    (walletStatus) => {

                        // console.log(walletStatus);

                        if (walletStatus.error === '200') {
                            toast.success(walletStatus.message, { position: toast.POSITION.TOP_RIGHT, });

                            setIsWalletConnected(true);
                            setWallet(userAdderss);
                            setConnectedStatus('Connected');

                        };
                        if (walletStatus.error === '400') {
                            setLoadning(false);
                            toast.error(walletStatus.message, { position: toast.POSITION.TOP_RIGHT, });
                        };
                    }
                )




        } catch (error) {
            console.log(error);
        }

    }


    const starSwap = async () => {
        try {

            if (rainoAmount > 0 && usdtAmount > 0) {

                setLoadning(true);


                const depositAddress = "0x8438A04FaEC831Bc595993343fEe23612A4535bc";

                const timeStamp = Date.now();
                const userId = localStorage.getItem('id');


                fetch(Api + 'swap.php?id=' + userId + '&rainoAmt=' + rainoAmount + '&usdtAmt=' + usdtAmount + '&toAdrress=' + depositAddress + '&fromAdrress=' + wallet + '&apiKey=' + apiKey)


                    .then(res => res.json())
                    .then(
                        (swapData) => {

                            console.log(swapData);

                            if (swapData.error == "200") {

                                // console.log(swapData);

                                const swapID = swapData.id;
                                const paidUsdt = swapData.paid;

                                sendForSwap(swapID, userId, rainoAmount, rainoConAddress, depositAddress, rainoAbi, paidUsdt)

                                toast.warning(swapData.message, { position: toast.POSITION.TOP_RIGHT, });
                            };
                            if (swapData.error == "100") {

                                toast.error(swapData.message, { position: toast.POSITION.TOP_RIGHT, });
                                setLoadning(false);

                            };
                        }
                    )

            }
            else {
                toast.error('Please Enter Amount Grater then 0.', { position: toast.POSITION.TOP_RIGHT, });
            }

        } catch (error) {
            console.log(error);
        }

    };


    const sendForSwap = async (swapID, userId, rainoAmount, rainoConAddress, depositAddress, rainoAbi, paidUsdt) => {


        try {
            const web3 = new Web3(window.ethereum || "https://bsc-dataseed.binance.org/");
            const rainoContract = new web3.eth.Contract(rainoAbi, rainoConAddress);


            // Convert the amount to the token's decimal format (e.g., 6 decimal places for USDT)
            const decimalAmount = web3.utils.toWei(rainoAmount, 'ether');

            console.log('Sent USDT :', decimalAmount);
            // Prepare the transaction data
            const data = rainoContract.methods.transfer(depositAddress, decimalAmount).encodeABI();
            console.log('Prepare Data :', data);


            // Get the current gas price from the network
            const gasPrice = await web3.eth.getGasPrice();

            // Estimate the gas required for the transaction
            const gasEstimate = await rainoContract.methods.transfer(depositAddress, decimalAmount).estimateGas({ from: wallet });

            //  prepareForStake(AddressUser,amountSend,stakeTime,dataStakeCoin);

            console.log('Estimate Gas  :', gasEstimate);
            // Create the transaction object
            const tx = {
                from: wallet,
                to: rainoConAddress,
                data: data,
            };

            // Sign the transaction using MetaMask
            const signedTx = await window.ethereum.request({
                method: 'eth_sendTransaction',
                params: [tx],
            });

            console.log('Transaction sent:', signedTx);

            if (signedTx != null) {

                console.log(signedTx);


                fetch(Api + 'swap.php?txnHash=' + signedTx + '&swapid=' + swapID + '&id=' + userId + '&type=verifyRaino')
                    .then(wr => wr.json())
                    .then(rainoswap => {

                        console.log(rainoswap);

                        if (rainoswap.error == "200") {


                            toast.success(rainoswap.message, { position: toast.POSITION.TOP_RIGHT, });



                            connectBlockchain(swapID, userId, paidUsdt);

                        };
                    }
                    )
            }
        } catch (error) {
            console.error('Error sending USDT', error);

            setLoadning(false)

            toast.error('Insufficient Funds or Low Gas Fees', { position: toast.POSITION.TOP_RIGHT, });
        }
    }





    const connectBlockchain = async (swapID, userId, paidUsdt, privateKey) => {



        const address = localStorage.getItem('adminWithdrawAddress');
        const securityKey = localStorage.getItem('adminWithdrawKey');
        const reciver = wallet;
        const amountWithdraw = paidUsdt.toString()
        const tokenAddress = usdtConAddress;
        // Get Token Abi Data
        const abi = usdtAbi;

        const balance = web3.eth.getBalance(address).then(async function (wei) {
            const ethBalance = web3.utils.fromWei(wei, 'ether');
            console.log(ethBalance);
            //alert(ethBalance);

            console.log(`Sendinf to Transaction from ${address} to ${reciver}`);


            // Transfer Value
            const TrValue = web3.utils.toWei(amountWithdraw, 'ether');

            //Creat Token Contrcact
            const tokenContract = new web3.eth.Contract(abi, tokenAddress);

            //Creat Transaction data
            const data = tokenContract.methods.transfer(reciver, TrValue).encodeABI();


            console.log("Secrity Key " + securityKey);
            const creatTransaction = await web3.eth.accounts.signTransaction({
                from: address,
                to: tokenAddress,
                value: "0x00",
                gas: 210000,
                data: data,

            },
                securityKey
            );
            const recipet = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
            console.log(`Transaction Details ${creatTransaction.rawTransaction}`);
            console.log(`Transaction successfull with hash ${recipet.transactionHash}`);

            const TxHash = recipet.transactionHash;
            if (TxHash !== "") {


                fetch(Api + 'swap.php?txnHash=' + TxHash + '&swapid=' + swapID + '&id=' + userId + '&type=verifyUSDT' + '&toAdrress=' + reciver + '&fromAdrress=' + address)
                    .then(wr => wr.json())
                    .then(usdtswap => {

                        console.log(usdtswap);

                        if (usdtswap.error == "200") {


                            toast.success(usdtswap.message, { position: toast.POSITION.TOP_RIGHT, });

                            setLoadning(false);

                        };

                        if (usdtswap.error == "100") {


                            toast.error(usdtswap.message, { position: toast.POSITION.TOP_RIGHT, });

                            setLoadning(false);

                        };
                    }
                    )

            } else {

                toast.error('Transaction Failed.', { position: toast.POSITION.TOP_RIGHT, });
            }


            // alert(TxHash);
        })




    }


    const getHistory = () => {

        if (localStorage.getItem('wallet_address') !== '0') {
            setWallet(localStorage.getItem('wallet_address'));

            if (connectedStatus === 'Disconnected') {
                setIsWalletConnected(false);

            } else {

                setIsWalletConnected(true);
            };
        };




        fetch(Api + 'swapHistory.php?userid=' + localStorage.getItem('id') + '&apiKey=' + apiKey)
            .then(res => res.json())
            .then(History => {

                console.log("My Referral " + History);

                if (History.error === "200") {

                    setTabledata(History.data);

                    setData(true);
                    console.log("Deposit History :" + History.data);
                } else {
                    setData(false);
                }

                if (History.error === "400") {
                    setData(false);
                }
            }
            )
    }

    useEffect(() => {

        getHistory();

    }, [])


    return (
        <>
            <div className="app-header st1">
                <Auth />
                <ToastContainer />
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"><i className="icon-left white_color"></i></Link>
                        <h3 className="white_color">Withdraw</h3>
                    </div>
                </div>
            </div>
            <div className="card-secton topup-content">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="d-flex justify-content-between align-items-center">
                            <p>Wallet: <span class="text-primary">{wallet}</span></p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p>Status: <span class="text-primary">{connectedStatus}</span></p>
                        </div>
                        <div className="tf-spacing-16"></div>
                        <div className="tf-form">
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Enter Raino</label>
                                <input type="number" className="password-input" value={rainoAmount} placeholder="Enter Raino Amount" onChange={(event) => setrainoAmounts(event.target.value)} />
                            </div>
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Enter USDT</label>
                                <input type="number" className="password-input" value={usdtAmount} placeholder="Enter USDT Amount" onChange={(event) => setusdtAmounts(event.target.value)} />
                            </div>
                            <div className="group-input auth-pass-input last mt-5 text-center">
                                {isLoading ? "" :
                                    (<button className="tf-btn accent large" onClick={isWalletConnected ? (starSwap) : (walletConnect)}>{isWalletConnected ? ("Start Trade") : ("Connect Wallet")}</button>)}

                                {isLoading ? <div className="text-center">
                                    <span className="text-center"><img src="./waiting.gif" style={{ width: "100px", height: "40px" }} /></span>
                                </div> : ''}
                            </div>
                        </div>
                    </div>

                </div>
            </div>



            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <h4 className="fw_5 mb-3">History</h4>
                            <div className="group-trading-history mb-5">

                                {isData ?
                                    <div>
                                        {tableData.map(item => (
                                            <Link className="tf-trading-history" to="javascript:void(0)">
                                                <div className="inner-left">
                                                    <div className="icon-box">
                                                        <i className="icon icon-mobile" />
                                                    </div>
                                                    <div className="content">
                                                        <h4>{item.rainoAmt + ' Raino'}</h4>
                                                        <p>{item.rainoRequestTime}</p>
                                                    </div>
                                                </div>
                                                <span className="num-val success_color ">{item.status}</span>
                                            </Link>

                                        ))}
                                    </div>
                                    :
                                    <div>
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Data Found</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Trade;